export default "__VITE_ASSET__CLj8rCPs__"